import gql from 'graphql-tag'

export const USER_WATCH_VIDEO = gql`
  mutation academyUserWatchVideo($watchedInput: VideoWatchedHistoryInput!) {
    academyUserWatchVideo(watchedHistory: $watchedInput) {
      id
    }
  }
`
